import React from 'react';

// Components
import Container from './components/Container';

const AuthBg = ({children}) => <Container>{children}</Container>;

export default AuthBg;
